import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';
import { ConfirmPasswordDialogComponent } from '../../popup/confirm-password-dialog/confirm-password-dialog.component';

import { JsonObject } from '@angular-devkit/core';
import { PaymentConfirmDialogComponent } from '../../popup/payment-confirm-dialog/payment-confirm-dialog.component';
import { CommonService, CartService } from "../../../_common/_service/user.service";
import { AuthenticationService } from '../../../_common/_service/authentication.service';
import { parse } from 'cookie';

@Component({
  selector: 'app-CourseContent',
  templateUrl: './CourseContent.component.html',
  styleUrls: ['./CourseContent.component.scss']
})
export class CourseContentComponent implements OnInit {
  userorderdetailList: any;
  show = 2;

  maxDate = new Date();
  currentUser: any;
  token: any;
  OptionList: any;
  UsertBal: any;
  serviceCode: any;
  countryIsdcode: any;
  MerchantList: any;
  loadingspinner: boolean = false;
  name: any;
  price: any;

  description: any;
  icon: any;
  whatLearn: any;
  otherDetailsrequirements: any;
  otherDetailsdescription: any;
  productid: any;
  ParentId: any;

  constructor(private authService: AuthService, private router: Router,
    private route: ActivatedRoute, public dialog: MatDialog,
    private fb: FormBuilder, private _cartservice: CartService,
    private toastr: ToastrService, private tokenStorageService: TokenStorageService, private tokenService: AuthenticationService, private _service: CommonService) {

    this.countryIsdcode = localStorage.getItem('countryIsdcode');



  }

  @Input() products: any[] | undefined;
  @Output() productAdded = new EventEmitter();

  //productslist: any;
  productslist: any[] = [];
  ngOnInit(): void {
    debugger

    this.token = this.tokenStorageService.getToken();
    this.serviceCode = this.route.snapshot.queryParams.serviceCode;
    if (this.token) {
      this.currentUser = this.tokenStorageService.getUser();
      this.UsertBal = this.tokenStorageService.getUsertBal();

      this.getproductlistbyid(this.serviceCode);
    }
    else {
      this._service.callMethodOfSecondComponent();
    }


  }

  Back() {

    this.router.navigate(['/Go-on']);
  }


  addProductToCart() {
    debugger;
    //this._cartservice.addToCart(this.userorderdetailList);
    this.loadingspinner = true;
    this._cartservice.addToCart(this.ParentId);
    this._cartservice.callMethodOfSecondComponent();

    this.loadingspinner = false;
    
  }

  

  

  

  getproductlistbyid(catgoryid: any) {
    
    var body = {
      categoryId: parseFloat(catgoryid)

    }
    this.loadingspinner = true;
    this.authService.getproductlistbyid(body).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; }) => {
      debugger;
      this.loadingspinner = false;
      if (response.apiStatus == true) {
        debugger;
        this.userorderdetailList = response.apiData;
        
        this.productid = response.apiData.Id;
        this.ParentId = response.apiData.ParentId;
        this.name = response.apiData.Name;
        this.description = response.apiData.Description;
        this.icon = response.apiData.Icon;

        //this.price = parseFloat(response.apiData.OtherDetails.Price) + parseFloat(response.apiData.OtherDetails.GstAmount);
        this.price = parseFloat(response.apiData.OtherDetails.Price);

        this.otherDetailsrequirements = response.apiData.OtherDetails.Requirements;
        this.otherDetailsdescription = response.apiData.OtherDetails.Description;
      }
      else if (response.apiStatus == false) {
        //    "apiMessage": "user account is disable",
        //this._service.callMethodOfSecondComponent();
      }
      else {
        this.toastr.error(response.apiMessage, 'Error');
      }

    }, (err: any) => {
      this.loadingspinner = false;
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }

  //apisubmgt() {
  //  debugger;

  //  if (this.show == 2) {
  //    this.loadingspinner = true;
  //    var post =
  //    {
  //      email: this.currentUser.email,
  //      amount: this.price,
  //      AccountServiceId: this.productid
  //    };

  //    debugger;
  //    this.authService.addMoneyRequestupi(post).subscribe((response: { apiStatus: boolean; apiMessage: any; apiData: any; transactionStatus: any }) => {

  //      this.loadingspinner = false;
  //      if (response.apiStatus == true) {

  //        window.location.href = response.apiData.Url;

  //      }
  //      else {
  //        this.toastr.error(response.apiMessage, 'Error');
  //      }
  //    }, (err: any) => {
  //      this.loadingspinner = false;
  //      if (err.error instanceof Error) {

  //        this.toastr.error(err.error, 'Error');
  //      } else {

  //        this.toastr.error(err.error, 'Error');
  //      }
  //    }
  //    );
  //  }

  //}


}
